import { create } from 'zustand';
import { LabType } from '@/types/labs';

interface LabTabState {
    selectedTab: LabType;
    setSelectedTab: (tab: LabType) => void;
}

export const useLabTabStore = create<LabTabState>((set) => ({
    selectedTab: 'general',
    setSelectedTab: (tab) => set({ selectedTab: tab }),
}));
